import React from "react";
import {  FaExclamationTriangle, FaClock, FaTags } from "react-icons/fa"; 
import PharmacyComponent from "./PharmacyComponent";
import { RiCapsuleFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const ClinicPharmacy = () => {
  const navigate =useNavigate();
  const pharmacystyles = `
  .pharmacy-container {
    margin: 0 auto;
    padding: 10px;
  }

  h1 {
    margin-bottom: 4px;
    font-size: 1.3rem;
  }

  .subtitle {
    color: #666;
    font-size: 1rem;
  }

  .header-1 {
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom: 20px;
  }

  .gradient-button:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }

  /* Stats Panel */
  .stats-panel {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 18px;
    margin-bottom: 24px;
  }

  .stat-card {
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 14px rgba(0,0,0,0.06);
    padding: 20px;
    transition: 0.3s;
    position: relative;
    overflow: hidden;
  }

  .stat-card::after {
    content: "";
    position: absolute;
    top: -40px;
    right: -40px;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    opacity: 0.15;
  }

  .stat-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.1);
  }

  .stat-icon {
    font-size: 2.2rem;
    margin-bottom: 12px;
  }

  .stat-title {
    color: #555;
    font-size: 1rem;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .stat-value {
    font-size: 1.2rem;
    font-weight: 700;
    color: #111;
  }

  .stat-sub {
    color: #777;
    font-size: 0.95rem;
    margin-top: 6px;
  }

  @media (max-width: 600px) {
    .pharmacy-container {
      padding: 8px;
    }
    .stat-card {
      padding: 15px;
    }
    .stat-value {
      font-size: 1.8rem;
    }
  }
  `;

  const stats = [
    {
      title: "Total Medicines",
      value: "1,248",
      sub: "+24 added this month",
      color: "#4CAF50",
      icon: <RiCapsuleFill className="stat-icon" style={{ color: "#4CAF50" }} />,
    },
    {
      title: "Low Stock Items",
      value: "42",
      sub: "Need reordering soon",
      color: "#FF9800", 
      icon: (
        <FaExclamationTriangle
          className="stat-icon"
          style={{ color: "#FF9800" }}
        />
      ),
    },
    {
      title: "Expiring Soon",
      value: "18",
      sub: "Within next 30 days",
      color: "#F44336", 
      icon: <FaClock className="stat-icon" style={{ color: "#F44336" }} />,
    },
    {
      title: "Categories",
      value: "36",
      sub: "Medicine categories",
      color: "#2196F3", 
      icon: <FaTags className="stat-icon" style={{ color: "#2196F3" }} />,
    },
  ];

  return (
    <>
      <style>{pharmacystyles}</style>
      <div className="pharmacy-container">
        {/* Header */}
        <div className="header-1">
          <div>
            <h1>Medicine List</h1>
            <p className="subtitle">
              Manage and view all medicines in the pharmacy inventory
            </p>
          </div>
          <div>
            <button onClick={()=>navigate("/AddPharmacy")} className="gradient-button">+ Add New Medicine</button>
          </div>
        </div>

        {/* Stats Panel */}
        <div className="stats-panel">
          {stats.map((stat, index) => (
            <div
              className="stat-card"
              key={index}
              style={{ "--circle-color": stat.color }}
            >
              {stat.icon}
              <div className="stat-title">{stat.title}</div>
              <div className="stat-value">{stat.value}</div>
              <div className="stat-sub">{stat.sub}</div>

              {/* Circle color */}
              <style>
                {`
                  .stats-panel .stat-card:nth-child(${index + 1})::after {
                    background: ${stat.color};
                  }
                `}
              </style>
            </div>
          ))}
        </div>
        <PharmacyComponent />
      </div>
    </>
  );
};

export default ClinicPharmacy;
